import { render } from "./Atencion_AtencionDet.vue?vue&type=template&id=ace521aa&scoped=true"
import script from "./Atencion_AtencionDet.vue?vue&type=script&lang=js"
export * from "./Atencion_AtencionDet.vue?vue&type=script&lang=js"

import "@/assets/css/listaFiltrada02.css?vue&type=style&index=0&id=ace521aa&scoped=true&lang=css"
import "./Atencion_AtencionDet.vue?vue&type=style&index=1&id=ace521aa&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ace521aa"]])

export default __exports__